import {fetchSettingsSuccess, ISettings} from "modules/actions";
import {createReducer} from "redux-act";

const defaultState: ISettingsReducer = {
	settings: undefined,
};

export interface ISettingsReducer {
	settings: ISettings | undefined;
}

const onFetchSettingsSuccess = (state: ISettingsReducer, payload: ISettings) => ({
	...state,
	settings: payload,
});

export const settings = createReducer<ISettingsReducer>({}, defaultState).on(
	fetchSettingsSuccess,
	onFetchSettingsSuccess
);
